// @ts-ignore
import React from "react";

import ImageChecklistSide from "@/patterns/image-checklist-side";

const Timeline = () => {
    const title = "Timeline";
    const listItems = [
        <>
            <strong>Keep teams aligned:</strong> Give your team the visibility
            they need to make fast and informed decisions while staying aligned
            with the bigger goals.
        </>,
        <>
            <strong>Track the big picture:</strong> Plan and track how you’re
            making progress on the big picture for a single team.
        </>,
        <>
            <strong>Get ahead of dependencies:</strong> Visualize dependencies
            within your team to account for them when making plans.
        </>,
        <>
            <strong>Plan with team capacity in mind (Advanced only):</strong>{" "}
            Ensure your teams have bandwidth to complete the work they’ve
            scoped. See multiple teams&apos; capacity on a sprint-by-sprint
            basis.
        </>
    ];
    const imageSrc =
        "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:1aac3c1e-a7f2-4a3c-a0d3-8f0ee32713fb/ConfluenceLP_Feature_Collaboration.png?cdnVersion=ecc";
    const imageAlt = "Jira timeline";

    return (
        <ImageChecklistSide
            title={title}
            listItems={listItems}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
        />
    );
};

export default Timeline;
